import React, { useState, useEffect } from 'react';
import FormGroupTextInput from "../formGroupTextInput";
import FormGroupSelectInput from "../formGroupSelectInput";
import FormGroupTextArea from "../formGroupTextArea";
import {FormGroup} from 'arag-ui-lib';
import {
    checkIfQuestionHasPendingChanges,
    checkIfQuestionsHasBeenModified,
    getDateQuestionMaximumValue,
    getDateQuestionMinimumValue, getTriggeredQuestionFromQuestionsMayBeTriggered, getTriggeredQuestion
} from "../../helpers/questions/functions";
import FormGroupDate from "../formGroupDate";
import {
    ANSWER_UPDATE_ACTION,
    DATE_REGEX_DD_MM_YYYY, DEFAULT_MEDICAL_EXPERT_FEE,
    DEFAULT_OPPONENT, INFO_TEXT_EDIT_WITH_APPROVAL, INFO_TEXT_EDIT_WITHOUT_APPROVAL,
    INVALID_DATES_ERROR_MESSAGE,CURRENCY, CURRENCY_CODE
} from "../../helpers/variables";

import FormGroupFileInput from "../formGroupFileInput";
import FormGroupTable from "../formGroupTable";
import ActionLink from "../General/actionLink";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../../helpers/approvalSettings/functions";
import QuestionEditActions from "./QuestionEditActions";
import {isSolicitorUser} from "../../helpers/functions";
import OpponentQuestion from "./opponentQuestion";
import {validateAmount, formatNumber } from "../../helpers/functions";
import '../../style/formGroupSelectInput.css'
import '../../style/formGroupTextInput.css'


const ApplicationQuestion = (props) => {
    const {
        question,
        formData,
        handleSelectChange,
        handleTextInputChange,
        handleDateChange,
        textAreaRows,
        onDrop,
        questions,
        filedDisabled,
        application,

        removeMedicalExpertFeesTableRow,
        isPlain,
        medExpertFees,
        updateMedicalExpertFees,
        breachCausationCp,
        onMedicalFeeAdd,

        extraOpponents,
        updateExtraOpponents,
        removeExtraOpponent,
        onOpponentAdd,
        opponentQuestions,

        rightData,
        rightWrapper,
        openHistoryModal,
        openEditQuestionAnswerModal,
        mapEditingQuestionOrFieldToEditingSetting,
        checkIfQuestionIsEditable,
        approvalOptions,
        attachments,
        onAttachmentRequest,
        openDeleteAnswerModal,
        onClickActionLink

    } = props;

    const [questionValidation, setQuestionValidation] = useState({}) 

    const validateAmountTypeQuestion = (questionId,value,minimum) => {
        var errMsg = validateAmount(value, minimum);
            setQuestionValidation({...questionValidation,[questionId]:errMsg});
        return errMsg; 
    }

    const handleBlur = (questionId, value, minValue) => {        
        const errMsg = validateAmountTypeQuestion(questionId, value, minValue);       
        if (!errMsg) {
            const formattedValue = formatNumber(props.formData[questionId]);
            handleTextInputChange(questionId, formattedValue);
        }
    }; 

    const getApprovalSettings = (question) => {
        const changesRequiresARAGApproval = 
            isPlain && checkIfQuestionAnswerUpdateRequiresARAGApproval(
                props.mapEditingQuestionOrFieldToEditingSetting(question),
                props.approvalOptions
            ) ? "edit-icon--orange" : null;

        const editingSetting = 
            props.isPlain ? props.mapEditingQuestionOrFieldToEditingSetting(question) : null;

        return { changesRequiresARAGApproval, editingSetting };
    };

    const handleEditRowClick = (expertFeeId) => {
        openEditQuestionAnswerModal({
            questionAnswerForEdit: question,
            questionAnswer: formData[question.id],
            questionAnswerMedicalExpertFees: [props.medExpertFees.find(i => i.id === expertFeeId)]
        });
    };

    const checkIfEditable = (question, section = null) => {
        return isPlain && checkIfQuestionIsEditable(
            question,
            null,
            section
        );
    };

    useEffect(() => {
        if (props.question.inputType === 'amount' && props.formData[props.question.id]) {   
            const formattedValue = formatNumber(props.formData[props.question.id]);              
            if (formattedValue !== props.formData[props.question.id]) {
                handleTextInputChange(props.question.id, formattedValue);
            }
        }
    }, [props.question.id]);

    if (question.machineName === 'OpponentName') {
        return (
            <div>
                {
                    extraOpponents.map((opponent, index) => {
                        return <OpponentQuestion
                            opponent={opponent}
                            opponentQuestions={opponentQuestions}
                            openHistoryModal={openHistoryModal}
                            application={application}
                            isPlain={isPlain}
                            question={question}
                            checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                            updateExtraOpponents={updateExtraOpponents}
                            opponentIndex={index}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                            approvalOptions={approvalOptions}
                            displayRemoveButton={(index > 0)}
                            onClickActionLink={onClickActionLink}
                                
                        />
                    })
                }
                
                <ActionLink
                    key={question.name}
                    label={"Add another"}
                    onClick={(
                        isPlain ?
                            () => openEditQuestionAnswerModal({
                                applicationUpdateAction: ANSWER_UPDATE_ACTION.ADD,
                                questionAnswerForEdit: question,
                                questionAnswerOpponent: DEFAULT_OPPONENT
                            })
                            :
                            onOpponentAdd
                    )}
                />
            </div>
        )
    }

    if (question.inputType === "table") {
        return (
            <div>
                <FormGroupTable
                    onInfoClick={(id) => openHistoryModal(question, id)}
                    checkIfRowHasBeenModified={(id) => checkIfQuestionsHasBeenModified(id, application, "EstimateForMedicalExpertFees")}
                    RightWrapper={'col-sm-3'}
                    rightData={
                        isPlain
                        && checkIfQuestionHasPendingChanges(question.id, application, "EstimateForMedicalExpertFees")
                        && (
                            <div className={"newApplication__awaiting-approval-wrapper pull-right"}>
                                Awaiting Approval
                            </div>
                        )
                    }
                    changesRequriesARAGApproval={getApprovalSettings(question).changesRequiresARAGApproval}
                    editingSetting={getApprovalSettings(question).editingSetting}
                    onDeleteRowClick={openDeleteAnswerModal}
                    onEditRowClick={handleEditRowClick}
                    areRowsEditable={checkIfEditable(question,"ApplicationMedicalExpertFees")}
                    removeMedicalExpertFeesTableRow={removeMedicalExpertFeesTableRow}
                    plain={isPlain}
                    LeftWrapper="col-sm-3"
                    InputWrapper="manageSolicitorAccount-data col-sm-6"
                    Label={question.name}
                    Required={question.isRequired}
                    medicalExpertFees={medExpertFees}
                    updateMedicalExpertFees={updateMedicalExpertFees}
                    breachCausationCp={breachCausationCp}
                />
                <ActionLink
                    key={question.name}
                    label={"Add another"}
                    onClick={(
                        isPlain ?
                            () => openEditQuestionAnswerModal({
                                applicationUpdateAction: ANSWER_UPDATE_ACTION.ADD,
                                questionAnswerForEdit: question,
                                questionAnswer: formData[question.id],
                                questionAnswerMedicalExpertFees: [DEFAULT_MEDICAL_EXPERT_FEE]
                            })
                            :
                            onMedicalFeeAdd
                    )}
                />
            </div>
        )
    }

    if (question.inputType === "upload") {
        return (
            <FormGroupFileInput
                onAttachmentRequest={onAttachmentRequest}
                attachments={
                    attachments ?
                        attachments.filter(a =>
                            a.questionId
                            && question.id
                            && a.questionId.toString() === question.id.toString()
                        )
                        :
                        []
                }
                isPlain={isPlain}
                RightValue={rightData}
                RightWrapper={rightWrapper}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Disabled={filedDisabled}
                DropzoneStyle="formGroup-textInput-input newApplication-upload-element"
                Label={question.name}
                Required={question.isRequired}
                Name={question.id}
                key={question.id}
                OnDrop={(files) => onDrop(files, question.id)}
            />
        )
    }

    if (question.inputType === "calendar") {
        let value = formData[question.id];
        let maxDate, minDate;
        // date field
        minDate = getDateQuestionMinimumValue(question, formData, questions);
        maxDate = getDateQuestionMaximumValue(question, formData, questions);
        // =====
        return <div key={question.id}>
            <FormGroupDate
                onLabelClick={() => openHistoryModal(question)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    question.id,
                    application
                )}
                isPlain={isPlain}
                rightData={<QuestionEditActions {...props}/>}
                RightWrapper={"col-sm-3"}
                title={INVALID_DATES_ERROR_MESSAGE}
                pattern={DATE_REGEX_DD_MM_YYYY}
                autoComplete={'off'}
                InputWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroup-textInput-input-wrapper"}`}
                Label={question.name}
                Required={question.isRequired}
                Name={question.id}
                key={question.id}
                Max={maxDate}
                Min={minDate}
                Type="text" Value={value}
                HandleInputChange={handleDateChange}/>
        </div>
    }

    if (question.inputType === 'text area') {
        return (
            <FormGroupTextArea
                onLabelClick={() => openHistoryModal(question)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    question.id,
                    application
                )}
                rightData={<QuestionEditActions {...props}/>}
                RightWrapper={"col-sm-3"}
                autoComplete={'off'}
                isPlain={isPlain}
                rows={textAreaRows}
                centerWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : " formGroupTextArea-wrapper"}`}
                required={question.isRequired}
                Label={question.name}
                Name={question.id}
                key={question.id}
                Value={formData[question.id]}
                HandleInputChange={handleTextInputChange}
            />
        )
    }

    if (question.inputType === 'text') {
        return (
            <FormGroupTextInput
                onLabelClick={() => openHistoryModal(question)}
                labelAsALink={checkIfQuestionsHasBeenModified(
                    question.id,
                    application
                )}
                isPlain={isPlain}
                rightData={<QuestionEditActions {...props}/>}
                RightWrapper={"col-sm-3"}
                autoComplete={'off'}
                InputWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroup-textInput-input-wrapper"}`}
                Label={question.name}
                Required={question.isRequired}
                Name={question.id}
                key={question.id}
                Type="text"
                Value={formData[question.id]}
                HandleInputChange={handleTextInputChange}
            />
        )
    }

    if (question.inputType === 'amount') {
        return (
            <div className="row" style={{ marginBottom: '10px' }}>
                <div className="col-sm-3">
                    <label
                        onClick={() => checkIfQuestionsHasBeenModified(
                            question.id,
                            application
                        ) ? openHistoryModal(question) : null}
                        className={
                            "control-label text-left formGroup-textInput-label" +
                            (checkIfQuestionsHasBeenModified(
                                question.id,
                                application
                            ) ? " formGroup--link-label" : "")
                        }
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        <p style={{ fontSize: '14px', margin: 0 }}>
                            {question.name}
                            {question.isRequired && (
                                <span style={{ color: '#94b494', marginLeft: '2px' }}>*</span>
                            )}
                        </p>                   
                    </label>
                </div>
                <div className="col-sm-6">
                    <FormGroup
                        errorMessage={questionValidation[question.id]}
                        variant={isPlain ? "plain" : "currency"}
                        inputSize="col-sm-12"
                        inputProps={{
                            value: formData[question.id],
                            key: question.id,
                            onBlur: () => handleBlur(question.id, formData[question.id], null),
                            name: question.id,
                            onChange: (e) => {
                                handleTextInputChange(e.target.name, e.target.value);
                                validateAmountTypeQuestion(e.target.name, e.target.value, null);
                            },
                            label: isPlain ? formData[question.id] : '',
                            disabledDropdown: true,
                            handleOptionSelect: () => {},
                            menuOptions: [
                                { sign: '£', code: 'GBP' },
                                { sign: '$', code: 'CAN' }
                            ],
                            selectedCurrency: { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                        }}
                    />
                </div>
                <div className="col-sm-3">
                    { <QuestionEditActions {...props} />}
                </div>
            </div>
        );
    }
    
    

    if (question.inputType === 'drop down') {
        const options = question.options.map(option => ({key: option.id, value: option.name}));
        options.unshift({key: '', value: ''});
        const selectedOptionId = formData[question.id];
        let optionChildQuestions = [];
        let selectedOption;
        if (selectedOptionId && options.length > 1) {
            selectedOption = question.options.find(option => option.id.toString() === selectedOptionId.toString());
            if (selectedOption) {
                optionChildQuestions = selectedOption.childQuestions;
            }
        }

        return (
            <div>
                <FormGroupSelectInput
                    openDeleteAnswerModal={openDeleteAnswerModal}
                    plainValue={selectedOption ? selectedOption.name : null}
                    isPlain={isPlain}
                    onLabelClick={() => openHistoryModal(question)}
                    labelAsALink={checkIfQuestionsHasBeenModified(
                        question.id,
                        application
                    )}
                    rightData={<QuestionEditActions {...props}/>}
                    RightWrapper={"col-sm-3"}
                    Label={question.name}
                    LeftWrapper="col-sm-3"
                    Required={question.isRequired}
                    Name={question.id}
                    Value={formData[question.id]} //todo: set value
                    key={question.id}
                    Options={options} //set options
                    HandleInputChange={handleSelectChange}
                    CenterWrapper={`col-sm-6 ${isPlain ? "manageSolicitorAccount-data" : "formGroupSelectInput-select-wrapper"}`}
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                {optionChildQuestions.map(cq => (
                    <ApplicationQuestion
                        onAttachmentRequest={onAttachmentRequest}
                        attachments={attachments}
                        approvalOptions={approvalOptions}
                        checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                        mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                        openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                        application={application}
                        openHistoryModal={openHistoryModal}
                        rightData={rightData}
                        rightWrapper={rightWrapper}
                        opponentQuestions={opponentQuestions}
                        extraOpponents={extraOpponents}
                        updateExtraOpponents={updateExtraOpponents}
                        removeExtraOpponent={removeExtraOpponent}
                        onOpponentAdd={onOpponentAdd}
                        onMedicalFeeAdd={onMedicalFeeAdd}
                        filedDisabled={filedDisabled}
                        onDrop={onDrop}
                        questions={questions}
                        key={cq.id}
                        textAreaRows={textAreaRows}
                        question={cq}
                        formData={formData}
                        handleTextInputChange={handleTextInputChange}
                        handleSelectChange={handleSelectChange}
                        handleDateChange={handleDateChange}
                        removeMedicalExpertFeesTableRow={removeMedicalExpertFeesTableRow}
                        isPlain={isPlain}
                        medExpertFees={medExpertFees}
                        updateMedicalExpertFees={updateMedicalExpertFees}
                        breachCausationCp={breachCausationCp}                       
                    />
                ))}
            </div>
        )
    }

    return null;

};

export default ApplicationQuestion;